module.exports = __webpack_public_path__ + "img/US_ConvertRate_ua.9ea17303.webp";